import React from 'react';
import './style.scss';
import LongTextTooltiper from "../../../Utils/LongTextTooltiper/LongTextTooltiper";

export default function OrderLabel(props) {
    return (
        <div className="order-label">
            <span className="order-label-text">
                <LongTextTooltiper backgroundColor="#efefef">
                    #{props.label ? props.label.split(' ')[0] : ''}
                </LongTextTooltiper>
            </span>
        </div>
    );
}